// Check if element exists
$.fn.elExists = function () {
    return this.length > 0;
};

//Shopify Object
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  let value = '';
  let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  let formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    let parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

// Site object
let website = new Object({

    // Defaults
    name: 'Vitality And Wellness',

    html: $('html'),
    body: $('body'),
    document: $(document),
    window: $(window),
    header: $('header'),
    restrictedCountriesDefault: 'AU',
    restrictedCountries: $('body').data('rc'),
    nonRestrictedProductClass: 'non-restricted-product',
    productList: $('.collection-products-section'),
    productDetail: $('.product-detail-page'),

    /*** Site Load ***/
    siteLoad: function(){

        // function currenceSlectorClass(){
        //     let currencetSelectCheck = $("select.currencies").val().toLowerCase();
        //     console.log(currencetSelectCheck);
        //     website.body.addClass('currency-select-'+currencetSelectCheck.toLowerCase());
        // }

        //console.log('v5.08');
        
        website.body.on('mouseover', '.sub-menu', function () {
            $(this).attr('aria-expanded', true);
        });
        website.body.on('mouseout', '.sub-menu', function () {
            $(this).attr('aria-expanded', false);
        });

        $('.maps').click(function(){
            $('.maps iframe').css("pointer-events", "auto");
        });

        //currenceSlectorClass();

    },

    /*** Responsive Youtube Videos ***/ 
    responsiveYoutube: function(target) {
        $(target).each(function() {
            $(this).wrap('<div class="video-responsive vid-youtube"></div>');
        }); 
    },

    /*** Responsive Vimeo Videos ***/ 
    responsiveVimeo: function(target) {
        $(target).each(function() {
            $(this).wrap('<div class="video-responsive vid-vimeo"></div>');
        }); 
    },

    contentTabs: function(target){
        target.each(function(){
            let $this = $(this);
            let tab = $this.find('> li > a');
            tab.on('click',function(e) {
                let $tab = $(this);
                let contentLocation = $tab.attr('href');
                if(contentLocation.charAt(0)=="#") {
                    e.preventDefault();
                    tab.removeClass('active');
                    $tab.addClass('active');
                    $tab.parents('ul.tabs').next().find(contentLocation).show().css({'display': 'block'}).addClass('active').siblings().hide().removeClass('active');
                }
            });
        });
    },

    sections: {

        //sections.bannerSlider();        
        bannerSlider: function(target){
            bedrock.require({ url:"https://cdn.shopify.com/s/files/1/2161/7185/t/32/assets/lightslider.min.js?v=5590738949478465258" }).then(function(){

                const bannerSlider = target;
                let slideAnimation = bannerSlider.data("slideshowanimation"),
                slideSpeed = bannerSlider.data("slideshowspeed"),
                slidePause = bannerSlider.data("slideshowpause");

                $(".banner-slider").lightSlider({
                    item: 1,
                    slideMargin: 0,
                    autoWidth: false,
                    mode: slideAnimation,
                    speed: slideSpeed, //ms'
                    auto: false,
                    enableDrag:false,
                    loop: true,
                    adaptiveHeight:false,
                    slideEndAnimation: true,
                    pause: slidePause,
                    onSliderLoad: function(el) {
                        let maxHeight = 0,
                            container = $(el),
                            children = container.children();
                        children.each(function () {
                            let childHeight = $(this).height();
                            if (childHeight > maxHeight) {
                                maxHeight = childHeight;
                            }
                            
                        });
                        $('.banner-slide').each(function(){
                            const $this = $(this);
                            let imgHeight = $this.find('.banner-filler-image').height();
                            $this.find('.hsContent').height(imgHeight);
                            $this.height(imgHeight);
                            $this.find('.container').height(imgHeight);
                            $this.find('.container >.row').height(imgHeight);
                            $('.lSSlideOuter').height(imgHeight);
                        });
                    }
                });

                $(window).on('resize',function(){
                    $('.banner-slide').each(function(){
                        const $this = $(this);
                        let imgHeight = $this.find('.banner-filler-image').height();
                        $this.find('.hsContent').height(imgHeight);
                        $this.height(imgHeight);
                        $this.find('.container').height(imgHeight);
                        $this.find('.container >.row').height(imgHeight);
                        $('.lSSlideOuter').height(imgHeight);
                    });
                    // $('.hsContent').each(function(i){
                    //     let heightFix = $(this).height();
                    //     heightFix = heightFix - 100;
                    //     $(this).find('.container').height(heightFix);
                    //     $(this).find('.container >.row').height(heightFix);
                    // });
                });
            });
        }
    },

    userProfiler: {

            userProfileClasses: function(){

                function actionResult(pData){
                    //console.log(personData);
                    if ( pData != undefined ){
                        if ( pData.country != undefined){
                            website.body.addClass("usercountry-"+pData.country.toLowerCase());
                        }
                        if ( pData.city != undefined  ){
                            website.body.addClass('user-city-'+pData.city.toLowerCase());
                        }
                    }
                }

                let personData = website.userProfiler.ipInfoDataCollect();
                if ( !personData ){
                    website.userProfiler.ipInfoDataCollectOnline().done(function(data){
                        personData = data;
                        actionResult(personData);
                    });
                }else{
                    actionResult(personData);
                }
                
            },

            ipInfoDataCollectOnline: function(){
                let profileData = "";
                const accessToken = "db275ab81bbf6e",
                jsonDataUrl = "https://ipinfo.io/json";

                const ipInfoUrl = jsonDataUrl + "?token=" +accessToken;

                return $.get(ipInfoUrl).pipe(function(response){
                    console.log('Requesting from ipinfo');
                    Cookies.set('ipi', response, { expires: 999, path: '/', domain: '.vitalityandwellness.com.au' });
                    profileData = response;
                    return profileData;
                }).fail(function() {
                    profileData = "Ipinfo Error";
                });
                
            },
        
            ipInfoDataCollect: function(){

                // const accessToken = "db275ab81bbf6e",
                // jsonDataUrl = "https://ipinfo.io/json";

                // const ipInfoUrl = jsonDataUrl + "?token=" +accessToken;

                let profileData = "",
                getCookieData = Cookies.getJSON('ipi');

                if ( getCookieData != undefined ){
                    profileData = getCookieData;
                    console.log('Requesting profile from cookie');
                }else{
                    console.log('Requesting from ipinfo required');

                }

                // console.log(profileData); // Use for testing

                return profileData;

            }
        
    },

    imageLoader: function(imageClass){
            let lazyloadImages = document.querySelectorAll("img."+imageClass),
            lazyloadThrottleTimeout;

            // function hasClass(element, className) {
            //     return (' ' + element.className + ' ').indexOf(' ' + className+ ' ') > -1;
            // }

            function isInViewport(element) {
                const rect = element.getBoundingClientRect();
                return (
                    rect.top >= 0 &&
                    rect.left >= 0 &&
                    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
                    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
                );
            }

            function pageLoad(){
                lazyloadImages.forEach(function(img) {
                    if ( isInViewport(img) ){
                        img.src = img.dataset.src;
                        img.classList.remove(imageClass);
                    }
                });
            }
            
            function lazyload () {
              if(lazyloadThrottleTimeout) {
                clearTimeout(lazyloadThrottleTimeout);
              }    
              
              lazyloadThrottleTimeout = setTimeout(function() {
                  let scrollTop = window.pageYOffset;
                  lazyloadImages.forEach(function(img) {
                      if(img.offsetTop < (window.innerHeight + scrollTop)) {
                        img.src = img.dataset.src;
                        img.classList.remove(imageClass);
                      }
                  });
                  if(lazyloadImages.length == 0) { 
                    document.removeEventListener("scroll", lazyload);
                    window.removeEventListener("resize", lazyload);
                    window.removeEventListener("orientationChange", lazyload);
                  }
              }, 20);
            }

            pageLoad();
            
            document.addEventListener("scroll", lazyload);
            window.addEventListener("resize", lazyload);
            window.addEventListener("orientationChange", lazyload);

    },

    currency:{

        targetPriceElement: $('.mval'),
        targetCurrencyType: $('.money >i'),

        loadedCurrency: function(){
                
                const $currencySelector = $('#currency-switcher'),
                $MainCartCurrencyDisplayPrice = $('#main-au-price-display');

                let selectCurrency = $currencySelector.data('defaultcurrency');
                let cookieCurrency = Cookies.get('currency');

                if ( cookieCurrency != null ){ 
                    selectCurrency = cookieCurrency;
                    $currencySelector.find('option[value="'+selectCurrency+'"]').attr("selected", "selected");
                }else{
                    selectCurrency = $currencySelector.val();
                }

                // If we are on AUD there is no point updating prices in a new currency format.
                if ( selectCurrency != "AUD" ){
                    website.currency.currencyPriceUpdate(selectCurrency,selectCurrency);
                    $MainCartCurrencyDisplayPrice.fadeIn();
                }

                if ( selectCurrency == "AUD" ){
                    $MainCartCurrencyDisplayPrice.fadeOut();
                }
                
                website.body.addClass('currency-select-'+selectCurrency.toLowerCase());

        },

        currencyPriceUpdate: function(oldCurrency,newCurrency,targetElements){
            
            const $currencySelector = $('#currency-switcher');

            let updatedCurrency = newCurrency,
            originalCurrency = oldCurrency;
            let targetElementVal = website.currency.targetPriceElement;

            if ( targetElements != undefined ){
                targetElementVal = targetElements;
            }

            if ( oldCurrency == newCurrency ){
                originalCurrency = $currencySelector.data('defaultcurrency');
            }

            Currency.convertAll(originalCurrency, updatedCurrency, targetElementVal);
            if ( website.currency.targetCurrencyType.length ){
                website.currency.targetCurrencyType.text(updatedCurrency);
            }

        },

        currencyChange: function(newCurrency,mode){

            const $currencySelector = $('#currency-switcher');

            let currentCurrency = $currencySelector.data('defaultcurrency'),
            currencyCookie = Cookies.get('currency');

            if (currencyCookie!= null){
                currentCurrency = currencyCookie;

            }
            website.currency.currencyPriceUpdate(currentCurrency,newCurrency);
    
        },

        globalCurrencyPageload: function(){

            if ( $('#product-detail').length == 0 ){
                const $currencySelector = $('#currency-switcher');
                //website.currency.currencyPriceUpdate('AUD',$currencySelector.val(),$('span.money'));
            }
          
        }

    },

    restrictions: {

        //website.restrictions.loadActualmages
        loadActualmages: function(){
            $('.restricted-product').each(function(){
                let $this = $(this);
                let thisImage = $this.find('.grid-restricted-image');
                $this.removeClass('hidden-image-product');
                thisImage.attr('src',thisImage.data('nri')).fadeIn();
            });
        },

        //website.restrictions.loadDetailImages
        loadDetailImages: function(){
            let thisImage = website.productDetail.find('.detail-restricted-image');
            website.productDetail.removeClass('hidden-image-product');
            thisImage.attr('src',thisImage.data('nri')).fadeIn();
        },

        //website.restrictions.cookieAccess
        cookieAccess: function(){
          
            let accessByCookie = Cookies.get('productaccess'),
            cookMeAccess = false;

            const openAccessClass = website.nonRestrictedProductClass;

            //console.log(accessByCookie);

            if (accessByCookie != undefined && accessByCookie == "true"){
                if ( website.productList.length ){
                    website.productList.addClass(openAccessClass);
                    website.restrictions.loadActualImages();
                }

                if ( website.productDetail.length ){
                    website.restrictions.loadDetailImages();
                    website.productDetail.addClass(openAccessClass);
                }

                cookMeAccess = true;
            }

            return cookMeAccess;

        },

        // restrictions.countryAccess
        // If not a restricted country we need to open up content limitations
        countryAccess: function(){

            let isItaRestrictedCountry = true;

            const openAccessClass = website.nonRestrictedProductClass;

            const productList = $('.collection-products-section'),
            productDetail = $('.product-detail-page');

            function isRestrictedCountry(countryCode){
                let rstCountries = website.restrictedCountries.toLowerCase();
                if(rstCountries == "" || rstCountries == undefined){
                    rstCountries = website.restrictedCountriesDefault.toLowerCase();
                }
                if ( rstCountries.indexOf(countryCode.toLowerCase()) !== -1 ){
                    return true;
                }else{
                    return false;
                }
            }

            function processAccess(pData){

                let countryRestrictionProduct = false,
                settingsCountries = website.body.data('rc').toLowerCase();

                // Check if country value exists and is in the restricted countrylist
                if ( pData.country != undefined && pData.country != "" ){

                    isItaRestrictedCountry = isRestrictedCountry(pData.country);
                    // Comment out for testing
                    //isItaRestrictedCountry = isRestrictedCountry('NZ');
                }

                if ( website.productDetail.length){
                    let prodRestricCountrys = $('#product-detail').data('prodrc');
                    //console.log('restriction product out: ' + prodRestricCountrys);
                    //console.log('restriction settings out: ' + settingsCountries);
                   
                    if(prodRestricCountrys!="" && prodRestricCountrys != undefined){
                        // //console.log(settingsCountries.indexOf(prodRestricCountrys) );
                        // if(settingsCountries.indexOf(prodRestricCountrys) !== -1){
                        //     countryRestrictionProduct = true;
                        // }
                        let dprodList = prodRestricCountrys.split(" ");

                        for (index = 0; index < dprodList.length; index++)
                        {
                            if(settingsCountries.indexOf(dprodList[index]) !== -1){
                                countryRestrictionProduct = true;
                                break;
                            }
                        }  
                    }

                }else if( productList.length){
                    // List view
                    let firstProdCheck = $('.grid-block').first().data('prodrc').trim();
                    if(firstProdCheck !="" && firstProdCheck != undefined){
                        let prodCList = firstProdCheck.split(" ");

                        for (index = 0; index < prodCList.length; index++)
                        {
                            if(settingsCountries.indexOf(prodCList[index]) !== -1){
                                countryRestrictionProduct = true;
                                break;
                            }
                        }                 
                    }
                   
                }

                /*
                //testing
                isItaRestrictedCountry = false;
                countryRestrictionProduct = false;
                console.log(isItaRestrictedCountry,countryRestrictionProduct);
                */
                
                if ( isItaRestrictedCountry == false && countryRestrictionProduct == false ){
                //if ( isItaRestrictedCountry == false ){
                    
                    if ( productList.length ){
                        website.productList.addClass(openAccessClass);
                        website.restrictions.loadActualmages();
                    }

                    if ( website.productDetail.length ){
                        // Check tags.

                        website.restrictions.loadDetailImages();
                        website.productDetail.addClass(openAccessClass);
                        $('#access-overlay').modal('hide');
                    }
                }
                website.body.addClass('rst-cntry-'+isItaRestrictedCountry.toString());

            }

            // Get Users Country
            //let console.log('get online'); = website.userProfiler.ipInfoDataCollect();

            // Go check for the cookie first
            let profileData = website.userProfiler.ipInfoDataCollect();

            if ( !profileData ){
                website.userProfiler.ipInfoDataCollectOnline().done(function(data){
                    profileData = data;
                    processAccess(profileData);
                });
            }else{
                processAccess(profileData);
            }

            // website.userProfiler.ipInfoDataCollect().done(function(data){
            //     profileData = data;
            // });        
        },

        //restrictions.restrctionForm
        restrctionForm: function(){

            const formHost = "https://formspree.io/f/mqnknylx ";
            const newFormHost = "https://formspree.io/f/mlearvjv";

            let $recForm = $('.restriction-access-form');

            function validateEmail($email) {
                var emailReg = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
                return emailReg.test( $email );
            }

            function recValidation(currentForm){

                let validated = 0;
                $recForm = currentForm;

                $recForm.find('.form-group').each(function(i, obj){
                    let $gGroup = $(this),
                    $gField = $gGroup.find('input');
                    $gGroupError = $gGroup.find('.form-g-error');

                    if ($gGroup.hasClass('required')){
                        if ( $gField.val() == "" ){
                            $gGroupError.show();
                            $gGroup .addClass('error');
                            //console.log('field-empty');
                            validated++;
                        }else{
                            $gGroupError.hide();
                            $gGroup.removeClass('error');                    
                        }
                    }
                });

                //validate email
                if ( $recForm.find('.email-group input').val() != "" ){
                    let validateEmailResult = validateEmail($recForm.find('.email-group input').val());
                    if ( validateEmailResult==true ){
                        $recForm.find('.email-group .form-g-error').hide().text('Required');
                    }else{
                        validated++;
                        //console.log('invalid email');
                        $recForm.find('.email-group .form-g-error').show().text('Valid email required');
                    }
                }

                if ( $('.product-detail-page.password-required').length ){
                    if ( $recForm.find('.requires-password input').val() == "" ){
                        $recForm.find('.requires-password .form-g-error').show();
                        //console.log('password required');
                        validated++;
                    }else{
                        $recForm.find('.requires-password .form-g-error').hide();
                    }
                }

                if ( $('.product-detail-page.prescription-required').length ){
                    if ($recForm.find('.upload-script input').get(0).files.length === 0) {
                        validated++;
                        $recForm.find('.upload-script .form-g-error').show();
                    }else{
                        $recForm.find('.upload-script .form-g-error').hide();
                    }

                }

                //console.log('infunction: '+validated);

                if (validated <0){
                    validated = 0;
                }

                return validated;

            }

            function formSubmitTrick(theForm){

                //const $theForm = $('.restriction-access-form');
                const $theForm = theForm;
                let dataValues = $theForm.serialize();
                const $Btn = $theForm.find('.secure-form-process-action');

                $theForm.find('.con-email').val($theForm.find('.pemail').val());
                $Btn.html('<i class="fas fa-circle-notch fa-spin"></i>');

                $theForm .submit();

                setTimeout(function(){
                    $theForm.find('.success').fadeIn();
                    $theForm.find('.form-body').addClass('submitted');

                    $Btn.html('View Product');
                    $('#access-overlay').modal('hide');
                    
                    setTimeout(function(){
                        location.reload();
                    }, 1000);

                    Cookies.set('productaccess', 'true', { expires: 99999, path: '/' });

                }, 2000);

            }

            // Possible update in future if not got file to attach.
            function submitFormAjax(){
                //Not used - unfinished
                let dataValues = $('.restriction-access-form').serialize();
                const $Btn = $('#secure-form-process-action');

                $('#con-email').val($('#pemail').val());
                $Btn.text('Processing');

                $.ajax({
                    url: newFormHost,
                    method: 'POST',
                    data:  dataValues 
                    }).done(function(data){
                        console.log('success');
                        console.log(data);

                        // Cookie alow access if valid
                        // Allow access

                    }).fail(function(e){
                        // Problem
                        console.log('fail');
                        console.log(e);
                        // $Btn.text('View Product');
                        // if ( e.responseJSON.error == "Invalid email address" ){
                        //     alert('There was a problem submitting the form. Please try again later.');
                        // }else{
                        //     alert(e.responseJSON.error);
                        // } 
                    });

            }

            $('.secure-form-process-action').on("click", function(e) {
                e.preventDefault();
                const currentForm = $(this).closest('.restriction-access-form');
                //console.log(currentForm.closest('.access-check').attr('class'));
                let pVal = parseInt(recValidation(currentForm));
                if (pVal > 0 ){
                    alert('Please ensure required fields are populated and you have entered a valid email.');
                }else{
                    //console.log('submit');
                    formSubmitTrick(currentForm);
                }
                
            });

        }

    },

    login: {
        forgotPassword: function(){
            $('#forgot-pass-link').on("click", function(e) {
                e.preventDefault();
                $('#recover-password').slideToggle();
            });
        },

        loginRedirect: function(){
            let redirect = document.referrer.replace("https://www.vitalityandwellness.com.au","");
            if ( redirect.indexOf('&') !== -1 ){
                redirect = redirect + "&";
            }else{
                redirect = redirect + "?";
            }

            redirect = redirect + "login=successfull";

            document.getElementById("prevpage").value = redirect;

            if (window.location.hash == '#recover') {
                $('#recover-password').slideDown();
            }
        }
    },

    products: {
        
        productPage: {

            pageLoad: function(){
                $('.product-description ul.tabs-content table').addClass('table');

                const $restrictionBox = $('#restriction-block'),
                $modalBody = $('#access-overlay .modal-body');

                function modalDataCompy(){
                    let $mainImgCopy = $('.product-detail-image.main-image').clone(),
                    $titleCopy = $('#product-title').data('hcollection');
                    $titleCopyNormal = $('#product-title').text();

                    if ( $('.hidden-name-product').length ){
                        $('.product-title-copy').html($titleCopy);
                    }else{
                        $('.product-title-copy').html($titleCopyNormal);
                    }
                    
                    $('.product-image-copy').html($mainImgCopy);
                }

                // $(window).on('load',function(){
                //     $restrictionBox.height($modalBody.height());
                // });

                // $(window).on('resize',function(){
                //     $restrictionBox.height($modalBody.height());  
                // });

                //If restricted
                modalDataCompy();

            },

            stockController: function(){
                let prodData = $('#prod-json').text(),
                prodJson = JSON.parse(prodData);

                let prdVarients = prodJson.variants;
                //console.log(prdVarients);

                const variantSelector = website.body.find('.product-variations select'),
                $cartBtn = $('.add_to_cart'),
                $noStockMsg = $('.out-of-stock-messaging'),
                $notifyForm = $('.notify_form'),
                $notifySuccess = $('.success-contact-message');

                function getQueryParams(qs) {
                    qs = qs.split('+').join(' ');
                
                    let params = {},
                        tokens,
                        re = /[?&]?([^=]+)=([^&]*)/g;
                
                    while (tokens = re.exec(qs)) {
                        params[decodeURIComponent(tokens[1])] = decodeURIComponent(tokens[2]);
                    }
                
                    return params;
                }                

                function outOfStock(){
                    $cartBtn.addClass('disabled');
                    $noStockMsg.fadeIn('fast');
                    if ( $notifyForm.length ){
                        $notifyForm.fadeIn('fast');
                    } 
                }

                function inStock(){
                    $cartBtn.removeClass('disabled');
                    $noStockMsg.fadeOut('fast');
                    if ( $notifyForm.length ){
                        $notifyForm.fadeOut('fast');
                    }
                }

                function matchImage(variantObject)
                {
                    //console.log('-- Match Image 3 --');
                    if ( variantObject != null ){
                        if ( variantObject.featured_image != null ){
                        let vrImageId = variantObject.featured_image.id;

                            $('#lightSlider li').each(function(){
                                let $slide = $(this),
                                slideImgID= $slide.find('img').data('imageid');
        
                                let itemIndex = $slide.index();
        
                                if ( slideImgID != undefined ){
                                    if ( slideImgID == vrImageId ){
                                        $('#lightSlider li').removeClass('active');
                                        $('.lSPager li').removeClass('active');
                                        $('.lSPager').find('li:eq('+itemIndex+')').addClass('active');
                                        $slide.addClass('active');
                                        $slide.find('img').fadeIn();
                                    }
                                }
                            });
                        }
                    }
                }

                function updatePrice(variantObject){

                    const $productForm = $('.product_form'),
                    $priceText = $('.product-info .main-money >b'),
                    $wasPriceText = $('.product-info .was-price .money >b');

                    let currentSelectedCountry = $('#currency-switcher').val();

                    let moneyFormat = $productForm.data('money-format');

                    let comparePrice = variantObject.compare_at_price,
                    mainPrice = variantObject.price;

                    //console.log(Currency.money_format[currentSelectedCountry]);
                    
                    // mainPrice = Shopify.formatMoney(mainPrice, moneyFormat).replace('$','');
                    // comparePrice = Shopify.formatMoney(comparePrice, moneyFormat).replace('$','');
                    moneyFormat = Currency.money_format[currentSelectedCountry];

                    if (currentSelectedCountry != "AUD"){
                        mainPrice = Currency.convert(mainPrice,'AUD',currentSelectedCountry);
                        comparePrice = Currency.convert(comparePrice,'AUD',currentSelectedCountry);
                    }

                    if( variantObject.price < variantObject.compare_at_price ){
                        $wasPriceText.html( Shopify.formatMoney(comparePrice, moneyFormat) );
                        
                    }else{
                        $wasPriceText.html("");
                    }

                    if (variantObject.price > 0) {
                        $priceText.html(Shopify.formatMoney(mainPrice, moneyFormat));
                    }else{
                        $priceText.html($productForm.data('freepricetext'));
                    }

                }

                function updateSkuID(variantObject){
                    //console.log(variantObject);
                    const $idField = $('#system-prod-id');
                    $idField.val(variantObject.id);
                }

                function checkVarient(){

                    const $notifyContent = $('.notify_form_message');

                    let currentVariant = variantSelector.val(),
                    baseNotifyMsg = $notifyContent.data('body'),
                    notifyDefault = $notifyContent.data('defaultval');

                    for (let i = 0; i < prdVarients.length; i++){
                        let vr = prdVarients[i];
                        if (currentVariant == vr.id){
                            //console.log(vr);
                            matchImage(vr);
                            updateSkuID(vr);

                            updatePrice(vr);
                            if ( vr.available == false ){
                                $notifyContent.attr('value',baseNotifyMsg + ' - ' + vr.title);
                                outOfStock();
                            }else{
                                inStock();
                            }
                        }
                    }
                }

                function successContactMessage(){
                    let query = getQueryParams(document.location.search),
                    checkSuccess = query.contact_posted;
                    if ( checkSuccess != undefined ){
                        if ( checkSuccess == "true" ){
                            $notifySuccess.fadeIn();
                        }
                    }
                }

                $(window).on('load', function(e){       
                    checkVarient();
                    
                });
                successContactMessage();

                website.body.on('click', '#show-script-request', function(e){
                    e.preventDefault();
                    $('.form-body .upload-script').toggle().toggleClass('show-script');
                    if ( $('.form-body .upload-script').hasClass('show-script')){
                        $(this).text('Cancel script');
                    }else{
                        $(this).text('Upload script');
                    }
                });
                
                website.body.on('change', '.product-variations select', function(e){
                    checkVarient();
                    $notifySuccess.hide();
                });
            },

            productImages: function(){
                bedrock.require({ url:"https://cdn.shopify.com/s/files/1/2161/7185/t/32/assets/lightslider.min.js?v=5590738949478465258" },{url:"https://cdn.shopify.com/s/files/1/2161/7185/t/32/assets/lightgallery.js?v=12035657819687754331676518459"}).then(function(){
                    //$('<link>').appendTo('head').attr({type: 'text/css', rel: 'stylesheet',href: 'https://cdn.shopify.com/s/files/1/2161/7185/t/32/assets/lightslider.min.css?v=13244757691497684580'});
                    var $lSlider = $("#lightSlider"),
                    useGallery = false,
                    usePager = false;
                    
                    if($lSlider.find('>li').length > 1){
                        useGallery = true;
                        usePager = true;
                    }

                    $lSlider.lightSlider({
                        item: 1,
                        gallery:useGallery,
                        slideMargin: 0,
                        pager:usePager,
                        autoWidth: false,
                        mode: "fade",
                        speed: 400, //ms'
                        auto: false,
                        loop: true,
                        slideEndAnimation: true,
                        pause: 2000,
                        onSliderLoad: function (el) {
                            $('.product-detail-image').addClass('loaded');
                        }
                    });
                    
                });
            },

            addToCart: function(){

                const productBody = $('#product-detail');
                const $productForm = $('form.product_form', productBody);
                let addToCartMessage = "Added to cart",
                variantInventory = $productForm.data('variant-inventory'),
                uniV = Math.random();

                function udpateCart(){
                    const miniCart = $('#mini-cart');

                    const slideCartAmount = $('#cart-item-totals'),
                    slideCartItems = $('#cart-item-list'),
                    slideCartSummary = $('#cart-totals-summary');
                    
                    miniCart.addClass('loading');
                    miniCart.find('a span').addClass('bounce');
                    
                    setTimeout(function(){
                        miniCart.removeClass('loading');
                        miniCart.find('a span').removeClass('bounce');
                        miniCart.load(location.href+ "?i="+ uniV +" #mini-cart>*","");

                        slideCartAmount.load(location.href+ "?i="+ uniV +" #cart-item-totals>*","");
                        slideCartItems.load(location.href+ "?i="+ uniV +" #cart-item-list>*","");
                        slideCartSummary.load(location.href+ "?i="+ uniV +" #cart-totals-summary*","");

                    }, 1000);
                }
                
                website.body.on('submit', '.product_form', function(e) {
                    e.preventDefault();

                    let $addToCartForm = $(this);
                    let $addToCartBtn = $addToCartForm.find('.add_to_cart');

                    addToCartMessage = productBody.data('addtocartsuccess');

                    $.ajax({
                      url: '/cart/add.js',
                      dataType: 'json',
                      type: 'post',
                      cache: false,
                      data: $addToCartForm.serialize(),
                      beforeSend: function() {
                        $addToCartBtn.attr('disabled', 'disabled').addClass('disabled');
                        //$addToCartBtn.find('span').removeClass("zoomIn").addClass('animated zoomOut');
                      }
                    }).done(function(data){

                        $addToCartBtn.find('span').text(addToCartMessage).addClass('fadeIn');
              
                        window.setTimeout(function(){
                          $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                          //$addToCartBtn.find('span').addClass("fadeOut").text($addToCartBtn.data('label')).removeClass('fadeIn').removeClass("fadeOut").addClass('zoomIn');
                        }, 1000);
              
                        $.ajax({
                          url: '/cart.js',
                          dataType: "json",
                          cache: false,
                        }).done(function(data){
                            udpateCart();
                            $addToCartBtn.find('span').text("Add To Cart").addClass('fadeIn');
                        }).fail(function(issue){
                            console.log('issue');
                        });

                    }).fail(function(issue){
                        var response = issue.responseText;
                        response = response.description;
                        $('.warning').remove();
                    
                        var warning = '<p class="warning animated bounceIn">' + response.replace('All 1 ', 'All ') + '</p>';
                        $addToCartForm.after(warning);
                        $addToCartBtn.removeAttr('disabled').removeClass('disabled');
                        $addToCartBtn.find('span').text(addToCartMessage).addClass('zoomIn');

                    });
                });
            }

        }

    },

    cart:{

        //cart.ukPricing
        ukPricing: function(orderString,minPrice){
            let ukCurrency = website.body.hasClass('currency-select-gbp'),
            ukCountry = website.body.hasClass('usercountry-gb'),
            ukCountrySecondary = website.body.hasClass('usercountry-uk');

            let $checkoutButtons = $('#checkout-main-buttons'),
            $miniCheckoutBtn = $('#dummy-mini-checkout');

            let orderValue = parseFloat(orderString),
            minPricValue = parseFloat(minPrice);

            if ( ukCurrency == true || ukCountry == true || ukCountrySecondary == true ){
                if ( orderValue <= minPricValue ){
                    $('.uk-order-message').fadeIn('fast');
                    $checkoutButtons.fadeOut('fast');
                    $miniCheckoutBtn.fadeOut('fast');
                }else{
                    $('.uk-order-message').fadeOut('fast');
                    $checkoutButtons.fadeIn('fast');
                    $miniCheckoutBtn.fadeIn('fast');
                }
            }
        },

        //cart.mainCart
        mainCart: function(){

            const $termsTick = $('#main-shopping-cart-section .tos_agree'),
            $checkBtn = $('#checkout');

            const $cartPage = $("main-shopping-cart-section");
            let minValue = website.body.data('minukval'),
            orderString = $('.cart-master-totals').data('defaulttotal').replace(/[^0-9\.-]+/g,"");

            if ( orderString == undefined || orderString == "" ){
                window.setTimeout(function(){
                    if ( $('.wh-cart-total').length ){
                        orderString = $('.wh-cart-total').text().replace(/[^0-9\.-]+/g,"");
                    }
                    website.cart.ukPricing(orderString,minValue);
                }, 4000);
            }else{
                // Order string price is empty though.
                website.cart.ukPricing(orderString,minValue);
            }

            $("input[name='updates[]']").on('input',function(){
                $("input[name='update']").trigger( "click" );
            });

            // $('body').on("click", ".qty-changer", function(){
            //     location.reload();
            // });

            website.body.on("change", "input[name='updates[]']", function(){
                location.reload();
            });

            
            website.body.on('click', 'label.tos_label', function() {
                $termsTick.trigger('click'); 
                $(this).toggleClass('terms-check-click');
            });
            
            website.body.on('click', '#dummy-checkout', function() {
                if ($termsTick.length) {
                    if ( $termsTick.is(':checked')){
                        $checkBtn.trigger('click');
                    }else{
                        alert('Please agree to the terms and conditions.');
                    }
                }else{
                    $checkBtn.trigger('click');
                }
            });

        },

        // cart.slideoutCart
        slideoutCart: function(){

            const $minTermsTick = $('#panel-cart .tos_agree'),
            $miniCheckoutBtn = $('#real-mini-checkout');

            let miniMinValue = website.body.data('minukval'),
            miniOrderString = $('#min-cart-defaultPrice').data('defaulttotal').replace(/[^0-9\.-]+/g,"");

            setTimeout(function(){ website.cart.ukPricing(miniOrderString,miniMinValue); }, 500);

            $('#dummy-mini-checkout').on('click',function(e) {
                e.preventDefault();
                if ($minTermsTick.length) {
                    if ( $minTermsTick.is(':checked')){
                        $miniCheckoutBtn.trigger('click');
                    }else{
                        alert('Please agree to the terms and conditions.');
                    }
                }else{
                    $miniCheckoutBtn.trigger('click');
                }
            });

        }
    },

    maps: {
        
        mapsLoad: function(){
            
            var mapsToLoad = [];

            function findLocation(mapArray) {
                var geoLat;
                var geoLng;
                var geocoder = new google.maps.Geocoder();
            
                //Find and set coordinates
                geocoder.geocode( { 'address': mapArray.address }, function(results, status) {
                    if (status == google.maps.GeocoderStatus.OK) {
            
                    geoLat = results[0].geometry.location.lat();
                    geoLng = results[0].geometry.location.lng();
            
                    //Create map
                    initMap(geoLat, geoLng, mapArray);
            
                    }
                });
            }

            function initMap(lat,lng, mapArray){
                let location = {lat: lat, lng: lng},
                styleJson = [];

                //Set style JSON
                if( mapArray.mapstyle == 'aubergine') {
                    styleJson = [{"elementType":"geometry","stylers":[{"color":"#1d2c4d"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#8ec3b9"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#1a3646"}]},{"featureType":"administrative.country","elementType":"geometry.stroke","stylers":[{"color":"#4b6878"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#64779e"}]},{"featureType":"administrative.province","elementType":"geometry.stroke","stylers":[{"color":"#4b6878"}]},{"featureType":"landscape.man_made","elementType":"geometry.stroke","stylers":[{"color":"#334e87"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#023e58"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#283d6a"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#6f9ba5"}]},{"featureType":"poi","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#023e58"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#3C7680"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#304a7d"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#98a5be"}]},{"featureType":"road","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#2c6675"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#255763"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#b0d5ce"}]},{"featureType":"road.highway","elementType":"labels.text.stroke","stylers":[{"color":"#023e58"}]},{"featureType":"transit","elementType":"labels.text.fill","stylers":[{"color":"#98a5be"}]},{"featureType":"transit","elementType":"labels.text.stroke","stylers":[{"color":"#1d2c4d"}]},{"featureType":"transit.line","elementType":"geometry.fill","stylers":[{"color":"#283d6a"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#3a4762"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#0e1626"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#4e6d70"}]}];
                } else if(mapArray.mapstyle == 'retro') {
                    styleJson = [{"elementType":"geometry","stylers":[{"color":"#ebe3cd"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#523735"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f1e6"}]},{"featureType":"administrative","elementType":"geometry.stroke","stylers":[{"color":"#c9b2a6"}]},{"featureType":"administrative.land_parcel","elementType":"geometry.stroke","stylers":[{"color":"#dcd2be"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#ae9e90"}]},{"featureType":"landscape.natural","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#93817c"}]},{"featureType":"poi.park","elementType":"geometry.fill","stylers":[{"color":"#a5b076"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#447530"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#f5f1e6"}]},{"featureType":"road.arterial","elementType":"geometry","stylers":[{"color":"#fdfcf8"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#f8c967"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#e9bc62"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry","stylers":[{"color":"#e98d58"}]},{"featureType":"road.highway.controlled_access","elementType":"geometry.stroke","stylers":[{"color":"#db8555"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#806b63"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"transit.line","elementType":"labels.text.fill","stylers":[{"color":"#8f7d77"}]},{"featureType":"transit.line","elementType":"labels.text.stroke","stylers":[{"color":"#ebe3cd"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#dfd2ae"}]},{"featureType":"water","elementType":"geometry.fill","stylers":[{"color":"#b9d3c2"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#92998d"}]}];
                } else if(mapArray.mapstyle == 'silver') {
                    styleJson = [{"elementType":"geometry","stylers":[{"color":"#f5f5f5"}]},{"elementType":"labels.icon","stylers":[{"visibility":"off"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#f5f5f5"}]},{"featureType":"administrative.land_parcel","elementType":"labels.text.fill","stylers":[{"color":"#bdbdbd"}]},{"featureType":"poi","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#ffffff"}]},{"featureType":"road.arterial","elementType":"labels.text.fill","stylers":[{"color":"#757575"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#dadada"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#616161"}]},{"featureType":"road.local","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"color":"#e5e5e5"}]},{"featureType":"transit.station","elementType":"geometry","stylers":[{"color":"#eeeeee"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#c9c9c9"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#9e9e9e"}]}];
                } else if(mapArray.mapstyle == 'night') {
                    styleJson =  [{"elementType":"geometry","stylers":[{"color":"#242f3e"}]},{"elementType":"labels.text.fill","stylers":[{"color":"#746855"}]},{"elementType":"labels.text.stroke","stylers":[{"color":"#242f3e"}]},{"featureType":"administrative.locality","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"poi.park","elementType":"geometry","stylers":[{"color":"#263c3f"}]},{"featureType":"poi.park","elementType":"labels.text.fill","stylers":[{"color":"#6b9a76"}]},{"featureType":"road","elementType":"geometry","stylers":[{"color":"#38414e"}]},{"featureType":"road","elementType":"geometry.stroke","stylers":[{"color":"#212a37"}]},{"featureType":"road","elementType":"labels.text.fill","stylers":[{"color":"#9ca5b3"}]},{"featureType":"road.highway","elementType":"geometry","stylers":[{"color":"#746855"}]},{"featureType":"road.highway","elementType":"geometry.stroke","stylers":[{"color":"#1f2835"}]},{"featureType":"road.highway","elementType":"labels.text.fill","stylers":[{"color":"#f3d19c"}]},{"featureType":"transit","elementType":"geometry","stylers":[{"color":"#2f3948"}]},{"featureType":"transit.station","elementType":"labels.text.fill","stylers":[{"color":"#d59563"}]},{"featureType":"water","elementType":"geometry","stylers":[{"color":"#17263c"}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"color":"#515c6d"}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"color":"#17263c"}]}];
                } else {
                    styleJson = [];
                }
            
                //Create google maps link
                $('.js-map-link').attr('href', 'https://www.google.com/maps/place/' + mapArray.directions + '/@' + lat + ',' + lng );
            
                //Set map options
                var mapOptions = {
                    zoom: mapArray.zoom,
                    center: location,
                    styles: styleJson,
                    disableDefaultUI: false
                };
            
                //Create map
                var map = new google.maps.Map(document.getElementById(mapArray.sectionid), mapOptions);
            
                //Show pin
                if(mapArray.showpin == true) {
                    var marker = new google.maps.Marker({
                    position: location,
                    map: map
                    });
                }
            }

            //Create map settings array
            $('.map').each(function(i, obj){
                mapsToLoad.push(this);
                mapsToLoad[i].sectionid = $(this).data('id');
                mapsToLoad[i].address = $(this).data('address');
                mapsToLoad[i].directions = $(this).data('directions-address');
                mapsToLoad[i].zoom = $(this).data('zoom');
                mapsToLoad[i].mapstyle = $(this).data('style');
                mapsToLoad[i].showpin = $(this).data('pin');
                mapsToLoad[i].apikey = $(this).data('api-key');
            });

            $.each(mapsToLoad, function(i,instance){

                //Enable caching to avoid duplicate google maps files
                $.ajaxSetup({ cache: true });

                //Load maps script and find location coordinates
                $.getScript('https://maps.googleapis.com/maps/api/js?key=' + mapsToLoad[i].apikey).then(function() {
                    findLocation(mapsToLoad[i]);
                    $.ajaxSetup({ cache: false });
                });
            });
        }

    }

});